// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { GetWareHousesData, GetWareHousesResponses, EditWareHouseData, EditWareHouseResponses, OnChangeStatusContainerData, OnChangeStatusContainerResponses, GetUsers1Data, GetUsers1Responses, InsertUserData, InsertUserResponses, UpdateUserData, UpdateUserResponses, DeleteUserData, DeleteUserResponses, ChangeUserStatusData, ChangeUserStatusResponses, CreateTraspasoData, CreateTraspasoResponses, EditTraspasoData, EditTraspasoResponses, SavePgData, SavePgResponses, EditPgData, EditPgResponses, ChangeOutputEmailData, ChangeOutputEmailResponses, GetCertificateByIdData, GetCertificateByIdResponses, EditOperationCertificateData, EditOperationCertificateResponses, EditStaticVolumeData, EditStaticVolumeResponses, EditReasonAndSolutionData, EditReasonAndSolutionResponses, DeleteHoseData, DeleteHoseResponses, UpdateHoseData, UpdateHoseResponses, UpdateHose1Data, UpdateHose1Responses, UpdateHosePriceBySubproductData, UpdateHosePriceBySubproductResponses, ChangeHoseStatusData, ChangeHoseStatusResponses, UpdateGaugeData, UpdateGaugeResponses, ChangeInputEquipmentStatusData, ChangeInputEquipmentStatusResponses, ChangeGaugeStatusData, ChangeGaugeStatusResponses, ChangeDispensaryStatusData, ChangeDispensaryStatusResponses, GetDistributionPointByIdData, GetDistributionPointByIdResponses, UpdateDistributionPointData, UpdateDistributionPointResponses, SetEnabledData, SetEnabledResponses, SaveDictumData, SaveDictumResponses, EditDictumData, EditDictumResponses, GetContainers1Data, GetContainers1Responses, InsertNewContainerData, InsertNewContainerResponses, EditContainersData, EditContainersResponses, OnChangeStatusContainer1Data, OnChangeStatusContainer1Responses, EditComplementData, EditComplementResponses, InsertWarehouseData, InsertWarehouseResponses, GenereteReportsData, GenereteReportsResponses, InsertManualRegisterData, InsertManualRegisterResponses, GetVolumeMeasurerRegisterData, GetVolumeMeasurerRegisterResponses, GetUsersData, GetUsersResponses, ChangeTemporalPasswordData, ChangeTemporalPasswordResponses, GenerateReportsData, GenerateReportsResponses, PrintMovementTicketData, PrintMovementTicketResponses, GenereteReports1Data, GenereteReports1Responses, AssignPreliminarPgData, AssignPreliminarPgResponses, SaveEmailConfigurationData, SaveEmailConfigurationResponses, GetCertificatesByFiltersData, GetCertificatesByFiltersResponses, InsertOperationCertificateData, InsertOperationCertificateResponses, GenereteReports2Data, GenereteReports2Responses, GetMovementsByEquipmentData, GetMovementsByEquipmentResponses, GetGeneralMovementsData, GetGeneralMovementsResponses, ExportGeneralSalesAsPdfData, ExportGeneralSalesAsPdfResponses, GetJrxmlFileData, GetJrxmlFileResponses, InsertJrxmlFileData, InsertJrxmlFileResponses, MarkJsonReportAsSentData, MarkJsonReportAsSentResponses, UploadAndUpdateJsonReportStatusByExcelSatFileData, UploadAndUpdateJsonReportStatusByExcelSatFileResponses, PreviewJsonData, PreviewJsonResponses, GenerateJsonData, GenerateJsonResponses, DownloadJsonData, DownloadJsonResponses, GetInventoryControlRegistersData, GetInventoryControlRegistersResponses, ExportInventoryControlAsPdfData, ExportInventoryControlAsPdfResponses, GetJsonReportListData, GetJsonReportListResponses, DownloadJsonReportsData, DownloadJsonReportsResponses, GetCurrentInventoryValuesData, GetCurrentInventoryValuesResponses, ReCalculateInventoryControlData, ReCalculateInventoryControlResponses, InsertInitialContainersData, InsertInitialContainersResponses, SaverUserData, SaverUserResponses, EmailTestData, EmailTestResponses, SaveSmtpEmailConfigData, SaveSmtpEmailConfigResponses, RedeemCodeData, RedeemCodeResponses, ValidateHistoricalDataLayoutFilesData, ValidateHistoricalDataLayoutFilesResponses, UploadHistoricalDataFileData, UploadHistoricalDataFileResponses, BuildJsonFilesData, BuildJsonFilesResponses, GetEventsData, GetEventsResponses, GenereteReports3Data, GenereteReports3Responses, RegisterNewManualEventData, RegisterNewManualEventResponses, GetAllDistributionPointsData, GetAllDistributionPointsResponses, CreateDistributionPointData, CreateDistributionPointResponses, TraspasosPageData, TraspasosPageResponses, GetActiveProductsByDistributionPointData, GetActiveProductsByDistributionPointResponses, InsertDispensaryData, InsertDispensaryResponses, GetDictumsData, GetDictumsResponses, GetLinearGraphInfoWsData, GetLinearGraphInfoWsResponses, GetCorruptedDataRegistersData, GetCorruptedDataRegistersResponses, InsertContainerGaugesData, InsertContainerGaugesResponses, InsertConfigApplicationData, InsertConfigApplicationResponses, UploadFielData, UploadFielResponses, ChangeConfigApplicationData, ChangeConfigApplicationResponses, InsertComplementData, InsertComplementResponses, GetCompanies1Data, GetCompanies1Responses, InsertCompanyData, InsertCompanyResponses, AssignCfdisData, AssignCfdisResponses, UploadZipCfdisData, UploadZipCfdisResponses, SyncCfdisData, SyncCfdisResponses, RecoverLostPasswordData, RecoverLostPasswordResponses, CreateAuthenticationTokenData, CreateAuthenticationTokenResponses, DownloadTemplateData, DownloadTemplateResponses, GetDistributionPointsByPermissionNumberData, GetDistributionPointsByPermissionNumberResponses, GetDistributionPointsByPermissionNumberErrors, CheckIfContainerKeyExistInWareHouseData, CheckIfContainerKeyExistInWareHouseResponses, GetWareHouseByIdData, GetWareHouseByIdResponses, GetWareHousesByWarehouseTypeData, GetWareHousesByWarehouseTypeResponses, CheckIfWareHouseKeyExistData, CheckIfWareHouseKeyExistResponses, GetUserData, GetUserResponses, CheckIfFirstUserExistData, CheckIfFirstUserExistResponses, EntitlementToRegisterData, EntitlementToRegisterResponses, GetSubscriptionData, GetSubscriptionResponses, GetPrintersData, GetPrintersResponses, GetReceptionsData, GetReceptionsResponses, GetContainersBySubproductData, GetContainersBySubproductResponses, GetDictumlessReceptionsData, GetDictumlessReceptionsResponses, GetProductsData, GetProductsResponses, GetProductByIdData, GetProductByIdResponses, GetPgsData, GetPgsResponses, GetPgByIdData, GetPgByIdResponses, AvailablePgsData, AvailablePgsResponses, GetOutputEmailData, GetOutputEmailResponses, GetEmailConfigurationsData, GetEmailConfigurationsResponses, GetEmailConfigurationTypesData, GetEmailConfigurationTypesResponses, DownloadJsonOperationCertificateData, DownloadJsonOperationCertificateResponses, GetMovementsData, GetMovementsResponses, GetMeasurementListJsonData, GetMeasurementListJsonResponses, GetJrxmlFilesData, GetJrxmlFilesResponses, FindJrxmlFileByTypeData, FindJrxmlFileByTypeResponses, GetInvoiceXmlDataData, GetInvoiceXmlDataResponses, GetInvoicePdfDataData, GetInvoicePdfDataResponses, GetPageableInventoryControlRegistriesByPeriodData, GetPageableInventoryControlRegistriesByPeriodResponses, DownloadInventoryControlRegistriesData, DownloadInventoryControlRegistriesResponses, DailyInventoryControlNotificationData, DailyInventoryControlNotificationResponses, ExistSmptConfigData, ExistSmptConfigResponses, OnboardingStatusData, OnboardingStatusResponses, ExistCompanyAdministratorData, ExistCompanyAdministratorResponses, GetCompaniesData, GetCompaniesResponses, GetHoseData, GetHoseResponses, CheckIfHoseKeyExistData, CheckIfHoseKeyExistResponses, CheckIfAuditableHoseKeyExistData, CheckIfAuditableHoseKeyExistResponses, DownloadHistoricalDataLayoutFileData, DownloadHistoricalDataLayoutFileResponses, GetHistoricalDataFilesStatusData, GetHistoricalDataFilesStatusResponses, GetProductSubProductsData, GetProductSubProductsResponses, GetProductActiveSubproductsData, GetProductActiveSubproductsResponses, GetActiveProductsData, GetActiveProductsResponses, GetApplicationVersionData, GetApplicationVersionResponses, GenerateUserLogoutEventData, GenerateUserLogoutEventResponses, GenerateInactivityLogoutEventData, GenerateInactivityLogoutEventResponses, GetEventTypeFilterData, GetEventTypeFilterResponses, GetEquipmentsData, GetEquipmentsResponses, GetEquipmentData, GetEquipmentResponses, CheckIfEquipmentKeyExistData, CheckIfEquipmentKeyExistResponses, CheckIfAuditableEquipmentKeyExistData, CheckIfAuditableEquipmentKeyExistResponses, GetEmailListData, GetEmailListResponses, GetPageableDistributionPointsData, GetPageableDistributionPointsResponses, GetLastMeasurementData, GetLastMeasurementResponses, GetWareHouses1Data, GetWareHouses1Responses, GetWareHousesByDistributionPointAndTypeData, GetWareHousesByDistributionPointAndTypeResponses, GetAllEquipmentsByApplicationTypeData, GetAllEquipmentsByApplicationTypeResponses, GetOriginTypeFilterData, GetOriginTypeFilterResponses, GetEquipmentsByDistributionPointData, GetEquipmentsByDistributionPointResponses, GetAllDispensariesData, GetAllDispensariesResponses, GetDictumlessReceptionsByDistributionPointIdData, GetDictumlessReceptionsByDistributionPointIdResponses, GetContainersData, GetContainersResponses, CheckIfWareHouseKeyExistInPddData, CheckIfWareHouseKeyExistInPddResponses, CheckIfAuditableEquipmentKeyExist1Data, CheckIfAuditableEquipmentKeyExist1Responses, GetActiveProductsByDistributionPoint1Data, GetActiveProductsByDistributionPoint1Responses, GetDispensaryEquipmentsByDispensaryCodeData, GetDispensaryEquipmentsByDispensaryCodeResponses, GetDictumByIdData, GetDictumByIdResponses, DownloadDictumFileData, DownloadDictumFileResponses, ValidateDailyJsonSchemaWsData, ValidateDailyJsonSchemaWsResponses, ValidateJsonSchemaWsMonthData, ValidateJsonSchemaWsMonthResponses, CreateLiveStatusSocketConectionData, CreateLiveStatusSocketConectionResponses, GetAllCorruptedDataRegistersData, GetAllCorruptedDataRegistersResponses, GetContainerByIdData, GetContainerByIdResponses, GetInstallationKeysData, GetInstallationKeysResponses, IntegrationCodeExistsData, IntegrationCodeExistsResponses, GetDuctKeysData, GetDuctKeysResponses, CountIfExistContainersData, CountIfExistContainersResponses, CheckIfContainerKeyExistData, CheckIfContainerKeyExistResponses, GetConfigApplicationData, GetConfigApplicationResponses, AllowManualWarehouseLevelData, AllowManualWarehouseLevelResponses, GetIncotermsData, GetIncotermsResponses, GetCountriesData, GetCountriesResponses, GetCompanyData, GetCompanyResponses, GetRegulatoryPermissionKeysData, GetRegulatoryPermissionKeysResponses, GetInstallationKeys1Data, GetInstallationKeys1Responses, GetCompanyInstallationKeyData, GetCompanyInstallationKeyResponses, GetCompanyActivityTypesData, GetCompanyActivityTypesResponses, SearchCfdisData, SearchCfdisResponses, DeletePgData, DeletePgResponses, DeleteEmailConfigurationData, DeleteEmailConfigurationResponses, DeleteHistoricalLayoutFileData, DeleteHistoricalLayoutFileResponses, DeleteAndMigrateHistoricalDataLayoutsData, DeleteAndMigrateHistoricalDataLayoutsResponses, DeleteEquipmentData, DeleteEquipmentResponses, DeleteDictumData, DeleteDictumResponses, DeleteContainerData, DeleteContainerResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getWareHouses = <ThrowOnError extends boolean = false>(options?: Options<GetWareHousesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWareHousesResponses, unknown, ThrowOnError>({
        url: '/warehouse',
        ...options
    });
};

export const editWareHouse = <ThrowOnError extends boolean = false>(options: Options<EditWareHouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditWareHouseResponses, unknown, ThrowOnError>({
        url: '/warehouse',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const onChangeStatusContainer = <ThrowOnError extends boolean = false>(options: Options<OnChangeStatusContainerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<OnChangeStatusContainerResponses, unknown, ThrowOnError>({
        url: '/warehouse/{warehouseId}/{status}',
        ...options
    });
};

export const getUsers1 = <ThrowOnError extends boolean = false>(options?: Options<GetUsers1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUsers1Responses, unknown, ThrowOnError>({
        url: '/user',
        ...options
    });
};

export const insertUser = <ThrowOnError extends boolean = false>(options: Options<InsertUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateUserResponses, unknown, ThrowOnError>({
        url: '/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DeleteUserResponses, unknown, ThrowOnError>({
        url: '/user/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeUserStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeUserStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeUserStatusResponses, unknown, ThrowOnError>({
        url: '/user/changeUserStatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const createTraspaso = <ThrowOnError extends boolean = false>(options: Options<CreateTraspasoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTraspasoResponses, unknown, ThrowOnError>({
        url: '/traspasos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editTraspaso = <ThrowOnError extends boolean = false>(options: Options<EditTraspasoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditTraspasoResponses, unknown, ThrowOnError>({
        url: '/traspasos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const savePg = <ThrowOnError extends boolean = false>(options: Options<SavePgData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SavePgResponses, unknown, ThrowOnError>({
        url: '/pgs/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editPg = <ThrowOnError extends boolean = false>(options: Options<EditPgData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditPgResponses, unknown, ThrowOnError>({
        url: '/pgs/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeOutputEmail = <ThrowOnError extends boolean = false>(options: Options<ChangeOutputEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeOutputEmailResponses, unknown, ThrowOnError>({
        url: '/outputEmail/changeOutputEmail',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCertificateById = <ThrowOnError extends boolean = false>(options: Options<GetCertificateByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCertificateByIdResponses, unknown, ThrowOnError>({
        url: '/operationCertificate/{certificateId}',
        ...options
    });
};

export const editOperationCertificate = <ThrowOnError extends boolean = false>(options: Options<EditOperationCertificateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditOperationCertificateResponses, unknown, ThrowOnError>({
        url: '/operationCertificate/{certificateId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editStaticVolume = <ThrowOnError extends boolean = false>(options: Options<EditStaticVolumeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditStaticVolumeResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/editStaticVolume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editReasonAndSolution = <ThrowOnError extends boolean = false>(options: Options<EditReasonAndSolutionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditReasonAndSolutionResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/editReasonAndSolution',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteHose = <ThrowOnError extends boolean = false>(options: Options<DeleteHoseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteHoseResponses, unknown, ThrowOnError>({
        url: '/hose/{idHose}',
        ...options
    });
};

export const updateHose = <ThrowOnError extends boolean = false>(options: Options<UpdateHoseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateHoseResponses, unknown, ThrowOnError>({
        url: '/hose/{idHose}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const updateHose1 = <ThrowOnError extends boolean = false>(options: Options<UpdateHose1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateHose1Responses, unknown, ThrowOnError>({
        url: '/hose/updateHose',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const updateHosePriceBySubproduct = <ThrowOnError extends boolean = false>(options: Options<UpdateHosePriceBySubproductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateHosePriceBySubproductResponses, unknown, ThrowOnError>({
        url: '/hose/updateHosePriceBySubproduct',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeHoseStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeHoseStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeHoseStatusResponses, unknown, ThrowOnError>({
        url: '/hose/changeHoseStatus/{idHose}/{status}',
        ...options
    });
};

export const updateGauge = <ThrowOnError extends boolean = false>(options: Options<UpdateGaugeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateGaugeResponses, unknown, ThrowOnError>({
        url: '/equipment/updateGauge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeInputEquipmentStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeInputEquipmentStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeInputEquipmentStatusResponses, unknown, ThrowOnError>({
        url: '/equipment/changeInputEquipmentStatus/{idEquipment}/{status}',
        ...options
    });
};

export const changeGaugeStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeGaugeStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeGaugeStatusResponses, unknown, ThrowOnError>({
        url: '/equipment/changeGaugeStatus/{idGauge}/{status}',
        ...options
    });
};

export const changeDispensaryStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeDispensaryStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeDispensaryStatusResponses, unknown, ThrowOnError>({
        url: '/equipment/changeDispensaryStatus/{equipmentId}/{status}',
        ...options
    });
};

export const getDistributionPointById = <ThrowOnError extends boolean = false>(options: Options<GetDistributionPointByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDistributionPointByIdResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{id}',
        ...options
    });
};

export const updateDistributionPoint = <ThrowOnError extends boolean = false>(options: Options<UpdateDistributionPointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDistributionPointResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const setEnabled = <ThrowOnError extends boolean = false>(options: Options<SetEnabledData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetEnabledResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{id}/{isEnabled}',
        ...options
    });
};

export const saveDictum = <ThrowOnError extends boolean = false>(options: Options<SaveDictumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveDictumResponses, unknown, ThrowOnError>({
        url: '/dictum',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editDictum = <ThrowOnError extends boolean = false>(options: Options<EditDictumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditDictumResponses, unknown, ThrowOnError>({
        url: '/dictum',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getContainers1 = <ThrowOnError extends boolean = false>(options?: Options<GetContainers1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetContainers1Responses, unknown, ThrowOnError>({
        url: '/container',
        ...options
    });
};

export const insertNewContainer = <ThrowOnError extends boolean = false>(options: Options<InsertNewContainerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertNewContainerResponses, unknown, ThrowOnError>({
        url: '/container',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editContainers = <ThrowOnError extends boolean = false>(options: Options<EditContainersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditContainersResponses, unknown, ThrowOnError>({
        url: '/container',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const onChangeStatusContainer1 = <ThrowOnError extends boolean = false>(options: Options<OnChangeStatusContainer1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<OnChangeStatusContainer1Responses, unknown, ThrowOnError>({
        url: '/container/{containerId}/changeStatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const editComplement = <ThrowOnError extends boolean = false>(options: Options<EditComplementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditComplementResponses, unknown, ThrowOnError>({
        url: '/complements/editComplement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertWarehouse = <ThrowOnError extends boolean = false>(options: Options<InsertWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertWarehouseResponses, unknown, ThrowOnError>({
        url: '/warehouse/insertwarehouse',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const genereteReports = <ThrowOnError extends boolean = false>(options: Options<GenereteReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenereteReportsResponses, unknown, ThrowOnError>({
        url: '/volumeMeasurerRegister/reports/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertManualRegister = <ThrowOnError extends boolean = false>(options: Options<InsertManualRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertManualRegisterResponses, unknown, ThrowOnError>({
        url: '/volumeMeasurerRegister/insertManualRegister',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getVolumeMeasurerRegister = <ThrowOnError extends boolean = false>(options: Options<GetVolumeMeasurerRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetVolumeMeasurerRegisterResponses, unknown, ThrowOnError>({
        url: '/volumeMeasurerRegister/getfilters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getUsers = <ThrowOnError extends boolean = false>(options: Options<GetUsersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetUsersResponses, unknown, ThrowOnError>({
        url: '/user/getUsers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeTemporalPassword = <ThrowOnError extends boolean = false>(options: Options<ChangeTemporalPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeTemporalPasswordResponses, unknown, ThrowOnError>({
        url: '/user/changeTemporalPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const generateReports = <ThrowOnError extends boolean = false>(options: Options<GenerateReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateReportsResponses, unknown, ThrowOnError>({
        url: '/traspasos/reports/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const printMovementTicket = <ThrowOnError extends boolean = false>(options: Options<PrintMovementTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PrintMovementTicketResponses, unknown, ThrowOnError>({
        url: '/sales/printMovement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const genereteReports1 = <ThrowOnError extends boolean = false>(options: Options<GenereteReports1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenereteReports1Responses, unknown, ThrowOnError>({
        url: '/receptions/reports/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assignPreliminarPg = <ThrowOnError extends boolean = false>(options: Options<AssignPreliminarPgData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignPreliminarPgResponses, unknown, ThrowOnError>({
        url: '/pg/preliminar/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const saveEmailConfiguration = <ThrowOnError extends boolean = false>(options: Options<SaveEmailConfigurationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveEmailConfigurationResponses, unknown, ThrowOnError>({
        url: '/outputEmail/saveEmailConfiguration',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCertificatesByFilters = <ThrowOnError extends boolean = false>(options: Options<GetCertificatesByFiltersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCertificatesByFiltersResponses, unknown, ThrowOnError>({
        url: '/operationCertificates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertOperationCertificate = <ThrowOnError extends boolean = false>(options: Options<InsertOperationCertificateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertOperationCertificateResponses, unknown, ThrowOnError>({
        url: '/operationCertificate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const genereteReports2 = <ThrowOnError extends boolean = false>(options: Options<GenereteReports2Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenereteReports2Responses, unknown, ThrowOnError>({
        url: '/movements/reports/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getMovementsByEquipment = <ThrowOnError extends boolean = false>(options: Options<GetMovementsByEquipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetMovementsByEquipmentResponses, unknown, ThrowOnError>({
        url: '/movements/getMovementsByEquipment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getGeneralMovements = <ThrowOnError extends boolean = false>(options: Options<GetGeneralMovementsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetGeneralMovementsResponses, unknown, ThrowOnError>({
        url: '/movements/getGeneralMovements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exportGeneralSalesAsPdf = <ThrowOnError extends boolean = false>(options: Options<ExportGeneralSalesAsPdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportGeneralSalesAsPdfResponses, unknown, ThrowOnError>({
        url: '/movements/getGeneralMovements/exportPDF',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getJrxmlFile = <ThrowOnError extends boolean = false>(options: Options<GetJrxmlFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJrxmlFileResponses, unknown, ThrowOnError>({
        url: '/jrxmlFiles/{type}',
        ...options
    });
};

export const insertJrxmlFile = <ThrowOnError extends boolean = false>(options: Options<InsertJrxmlFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertJrxmlFileResponses, unknown, ThrowOnError>({
        url: '/jrxmlFiles/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const markJsonReportAsSent = <ThrowOnError extends boolean = false>(options: Options<MarkJsonReportAsSentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MarkJsonReportAsSentResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/jsonReport/{idJsonReport}/verified/{sent}',
        ...options
    });
};

export const uploadAndUpdateJsonReportStatusByExcelSatFile = <ThrowOnError extends boolean = false>(options?: Options<UploadAndUpdateJsonReportStatusByExcelSatFileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UploadAndUpdateJsonReportStatusByExcelSatFileResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/inventoryControl/jsonReport/uploadStatusFile',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const previewJson = <ThrowOnError extends boolean = false>(options: Options<PreviewJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewJsonResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/jsonReport/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const generateJson = <ThrowOnError extends boolean = false>(options: Options<GenerateJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateJsonResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/jsonReport/generate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const downloadJson = <ThrowOnError extends boolean = false>(options: Options<DownloadJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DownloadJsonResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/jsonReport/download',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getInventoryControlRegisters = <ThrowOnError extends boolean = false>(options: Options<GetInventoryControlRegistersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetInventoryControlRegistersResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/getRegisters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * @deprecated
 */
export const exportInventoryControlAsPdf = <ThrowOnError extends boolean = false>(options: Options<ExportInventoryControlAsPdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportInventoryControlAsPdfResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/getRegisters/ExportPDF',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getJsonReportList = <ThrowOnError extends boolean = false>(options: Options<GetJsonReportListData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetJsonReportListResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/getJsonReportList',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const downloadJsonReports = <ThrowOnError extends boolean = false>(options: Options<DownloadJsonReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DownloadJsonReportsResponses, unknown, ThrowOnError>({
        responseType: 'blob',
        url: '/inventoryControl/downloadJsonReportZip',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCurrentInventoryValues = <ThrowOnError extends boolean = false>(options: Options<GetCurrentInventoryValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCurrentInventoryValuesResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/currentInventory',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const reCalculateInventoryControl = <ThrowOnError extends boolean = false>(options: Options<ReCalculateInventoryControlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReCalculateInventoryControlResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/calculatedGics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertInitialContainers = <ThrowOnError extends boolean = false>(options: Options<InsertInitialContainersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertInitialContainersResponses, unknown, ThrowOnError>({
        url: '/insertFirstContainer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const saverUser = <ThrowOnError extends boolean = false>(options: Options<SaverUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaverUserResponses, unknown, ThrowOnError>({
        url: '/initial-config/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const emailTest = <ThrowOnError extends boolean = false>(options: Options<EmailTestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EmailTestResponses, unknown, ThrowOnError>({
        url: '/initial-config/smtp/test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const saveSmtpEmailConfig = <ThrowOnError extends boolean = false>(options: Options<SaveSmtpEmailConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveSmtpEmailConfigResponses, unknown, ThrowOnError>({
        url: '/initial-config/smtp-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const redeemCode = <ThrowOnError extends boolean = false>(options: Options<RedeemCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RedeemCodeResponses, unknown, ThrowOnError>({
        url: '/initial-config/redeemCode',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const validateHistoricalDataLayoutFiles = <ThrowOnError extends boolean = false>(options: Options<ValidateHistoricalDataLayoutFilesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ValidateHistoricalDataLayoutFilesResponses, unknown, ThrowOnError>({
        url: '/historicalData/validateHistoricalDataLayoutFiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const uploadHistoricalDataFile = <ThrowOnError extends boolean = false>(options: Options<UploadHistoricalDataFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadHistoricalDataFileResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/historicalData/uploadFile',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

export const buildJsonFiles = <ThrowOnError extends boolean = false>(options: Options<BuildJsonFilesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BuildJsonFilesResponses, unknown, ThrowOnError>({
        url: '/historicalData/buildJsonFiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getEvents = <ThrowOnError extends boolean = false>(options: Options<GetEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetEventsResponses, unknown, ThrowOnError>({
        url: '/events',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const genereteReports3 = <ThrowOnError extends boolean = false>(options: Options<GenereteReports3Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenereteReports3Responses, unknown, ThrowOnError>({
        url: '/events/reports/{type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const registerNewManualEvent = <ThrowOnError extends boolean = false>(options: Options<RegisterNewManualEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegisterNewManualEventResponses, unknown, ThrowOnError>({
        url: '/events/registerNewManualEvent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getAllDistributionPoints = <ThrowOnError extends boolean = false>(options?: Options<GetAllDistributionPointsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllDistributionPointsResponses, unknown, ThrowOnError>({
        url: '/distributionPoints',
        ...options
    });
};

export const createDistributionPoint = <ThrowOnError extends boolean = false>(options: Options<CreateDistributionPointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDistributionPointResponses, unknown, ThrowOnError>({
        url: '/distributionPoints',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const traspasosPage = <ThrowOnError extends boolean = false>(options: Options<TraspasosPageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TraspasosPageResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/traspasos',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getActiveProductsByDistributionPoint = <ThrowOnError extends boolean = false>(options: Options<GetActiveProductsByDistributionPointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetActiveProductsByDistributionPointResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/activeProducts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertDispensary = <ThrowOnError extends boolean = false>(options: Options<InsertDispensaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertDispensaryResponses, unknown, ThrowOnError>({
        url: '/dispensary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getDictums = <ThrowOnError extends boolean = false>(options: Options<GetDictumsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetDictumsResponses, unknown, ThrowOnError>({
        url: '/dictum/getDictums',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getLinearGraphInfoWs = <ThrowOnError extends boolean = false>(options: Options<GetLinearGraphInfoWsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetLinearGraphInfoWsResponses, unknown, ThrowOnError>({
        url: '/dashboard/linearGraphInfoWS',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCorruptedDataRegisters = <ThrowOnError extends boolean = false>(options: Options<GetCorruptedDataRegistersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCorruptedDataRegistersResponses, unknown, ThrowOnError>({
        url: '/corruptedDataStorage/getRegisters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertContainerGauges = <ThrowOnError extends boolean = false>(options: Options<InsertContainerGaugesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertContainerGaugesResponses, unknown, ThrowOnError>({
        url: '/container/insertContainerGauges',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertConfigApplication = <ThrowOnError extends boolean = false>(options: Options<InsertConfigApplicationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertConfigApplicationResponses, unknown, ThrowOnError>({
        url: '/configApplication',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const uploadFiel = <ThrowOnError extends boolean = false>(options: Options<UploadFielData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadFielResponses, unknown, ThrowOnError>({
        url: '/configApplication/upload/fiel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeConfigApplication = <ThrowOnError extends boolean = false>(options: Options<ChangeConfigApplicationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeConfigApplicationResponses, unknown, ThrowOnError>({
        url: '/configApplication/changeConfigApplication',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const insertComplement = <ThrowOnError extends boolean = false>(options: Options<InsertComplementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertComplementResponses, unknown, ThrowOnError>({
        url: '/complements/insertComplement',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getCompanies1 = <ThrowOnError extends boolean = false>(options?: Options<GetCompanies1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompanies1Responses, unknown, ThrowOnError>({
        url: '/company',
        ...options
    });
};

export const insertCompany = <ThrowOnError extends boolean = false>(options: Options<InsertCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InsertCompanyResponses, unknown, ThrowOnError>({
        url: '/company',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const assignCfdis = <ThrowOnError extends boolean = false>(options: Options<AssignCfdisData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignCfdisResponses, unknown, ThrowOnError>({
        url: '/cfdis/{type}/{id}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const uploadZipCfdis = <ThrowOnError extends boolean = false>(options?: Options<UploadZipCfdisData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UploadZipCfdisResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/cfdis/zip/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

export const syncCfdis = <ThrowOnError extends boolean = false>(options: Options<SyncCfdisData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncCfdisResponses, unknown, ThrowOnError>({
        url: '/cfdis/sync',
        ...options
    });
};

export const recoverLostPassword = <ThrowOnError extends boolean = false>(options: Options<RecoverLostPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecoverLostPasswordResponses, unknown, ThrowOnError>({
        url: '/auth/recoverLostPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const createAuthenticationToken = <ThrowOnError extends boolean = false>(options: Options<CreateAuthenticationTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAuthenticationTokenResponses, unknown, ThrowOnError>({
        url: '/auth/authenticate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const downloadTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadTemplateResponses, unknown, ThrowOnError>({
        url: '/{distributionId}/template/traspasos',
        ...options
    });
};

/**
 * Obtiene los almacenes agrupados por número de permiso
 */
export const getDistributionPointsByPermissionNumber = <ThrowOnError extends boolean = false>(options?: Options<GetDistributionPointsByPermissionNumberData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDistributionPointsByPermissionNumberResponses, GetDistributionPointsByPermissionNumberErrors, ThrowOnError>({
        responseType: 'json',
        security: [
            {
                name: 'X-API-KEY',
                type: 'apiKey'
            }
        ],
        url: '/warehousesByPermissionNumber',
        ...options
    });
};

export const checkIfContainerKeyExistInWareHouse = <ThrowOnError extends boolean = false>(options: Options<CheckIfContainerKeyExistInWareHouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfContainerKeyExistInWareHouseResponses, unknown, ThrowOnError>({
        url: '/warehouse/{warehouseId}/checkIfContainerKeyExist',
        ...options
    });
};

export const getWareHouseById = <ThrowOnError extends boolean = false>(options: Options<GetWareHouseByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWareHouseByIdResponses, unknown, ThrowOnError>({
        url: '/warehouse/{idWarehouse}',
        ...options
    });
};

export const getWareHousesByWarehouseType = <ThrowOnError extends boolean = false>(options: Options<GetWareHousesByWarehouseTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWareHousesByWarehouseTypeResponses, unknown, ThrowOnError>({
        url: '/warehouse/getByWarehouseType/{warehouseType}',
        ...options
    });
};

export const checkIfWareHouseKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfWareHouseKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfWareHouseKeyExistResponses, unknown, ThrowOnError>({
        url: '/warehouse/checkIfWareHouseKeyExist/{wareHouseKey}',
        ...options
    });
};

export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserResponses, unknown, ThrowOnError>({
        url: '/user/{id}',
        ...options
    });
};

export const checkIfFirstUserExist = <ThrowOnError extends boolean = false>(options?: Options<CheckIfFirstUserExistData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckIfFirstUserExistResponses, unknown, ThrowOnError>({
        url: '/user/checkIfFirstUserExist',
        ...options
    });
};

export const entitlementToRegister = <ThrowOnError extends boolean = false>(options?: Options<EntitlementToRegisterData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<EntitlementToRegisterResponses, unknown, ThrowOnError>({
        url: '/subscriptions/entitlement/register',
        ...options
    });
};

export const getSubscription = <ThrowOnError extends boolean = false>(options?: Options<GetSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSubscriptionResponses, unknown, ThrowOnError>({
        url: '/subscription/subscriptionDetail',
        ...options
    });
};

export const getPrinters = <ThrowOnError extends boolean = false>(options?: Options<GetPrintersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPrintersResponses, unknown, ThrowOnError>({
        url: '/sales/getPrinters',
        ...options
    });
};

export const getReceptions = <ThrowOnError extends boolean = false>(options: Options<GetReceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReceptionsResponses, unknown, ThrowOnError>({
        url: '/receptions',
        ...options
    });
};

export const getContainersBySubproduct = <ThrowOnError extends boolean = false>(options: Options<GetContainersBySubproductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContainersBySubproductResponses, unknown, ThrowOnError>({
        url: '/receptions/getReceptionById/{idReception}',
        ...options
    });
};

export const getDictumlessReceptions = <ThrowOnError extends boolean = false>(options?: Options<GetDictumlessReceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDictumlessReceptionsResponses, unknown, ThrowOnError>({
        url: '/receptions/getDictumlessReceptions/',
        ...options
    });
};

export const getProducts = <ThrowOnError extends boolean = false>(options?: Options<GetProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetProductsResponses, unknown, ThrowOnError>({
        url: '/products',
        ...options
    });
};

export const getProductById = <ThrowOnError extends boolean = false>(options: Options<GetProductByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProductByIdResponses, unknown, ThrowOnError>({
        url: '/products/{id}',
        ...options
    });
};

export const getPgs = <ThrowOnError extends boolean = false>(options?: Options<GetPgsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPgsResponses, unknown, ThrowOnError>({
        url: '/pgs',
        ...options
    });
};

export const getPgById = <ThrowOnError extends boolean = false>(options: Options<GetPgByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPgByIdResponses, unknown, ThrowOnError>({
        url: '/pgs/{id}',
        ...options
    });
};

export const availablePgs = <ThrowOnError extends boolean = false>(options?: Options<AvailablePgsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AvailablePgsResponses, unknown, ThrowOnError>({
        url: '/pgs/preliminar/search',
        ...options
    });
};

export const getOutputEmail = <ThrowOnError extends boolean = false>(options?: Options<GetOutputEmailData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOutputEmailResponses, unknown, ThrowOnError>({
        url: '/outputEmail/getOutputEmail',
        ...options
    });
};

export const getEmailConfigurations = <ThrowOnError extends boolean = false>(options?: Options<GetEmailConfigurationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEmailConfigurationsResponses, unknown, ThrowOnError>({
        url: '/outputEmail/getEmailConfigurations',
        ...options
    });
};

export const getEmailConfigurationTypes = <ThrowOnError extends boolean = false>(options?: Options<GetEmailConfigurationTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEmailConfigurationTypesResponses, unknown, ThrowOnError>({
        url: '/outputEmail/getEmailConfigurationTypes',
        ...options
    });
};

export const downloadJsonOperationCertificate = <ThrowOnError extends boolean = false>(options: Options<DownloadJsonOperationCertificateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadJsonOperationCertificateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/operationCertificate/{certificateId}/{fileType}/download',
        ...options
    });
};

export const getMovements = <ThrowOnError extends boolean = false>(options?: Options<GetMovementsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMovementsResponses, unknown, ThrowOnError>({
        url: '/movements',
        ...options
    });
};

export const getMeasurementListJson = <ThrowOnError extends boolean = false>(options: Options<GetMeasurementListJsonData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMeasurementListJsonResponses, unknown, ThrowOnError>({
        url: '/measurements/{wareHouseInventoryControlId}',
        ...options
    });
};

export const getJrxmlFiles = <ThrowOnError extends boolean = false>(options?: Options<GetJrxmlFilesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetJrxmlFilesResponses, unknown, ThrowOnError>({
        url: '/jrxmlFiles',
        ...options
    });
};

export const findJrxmlFileByType = <ThrowOnError extends boolean = false>(options: Options<FindJrxmlFileByTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FindJrxmlFileByTypeResponses, unknown, ThrowOnError>({
        url: '/jrxmlFiles/getFile/{jrxmlType}',
        ...options
    });
};

export const getInvoiceXmlData = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceXmlDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInvoiceXmlDataResponses, unknown, ThrowOnError>({
        url: '/invoiceApp/xmlInvoice/{cfdiId}',
        ...options
    });
};

export const getInvoicePdfData = <ThrowOnError extends boolean = false>(options: Options<GetInvoicePdfDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInvoicePdfDataResponses, unknown, ThrowOnError>({
        url: '/invoiceApp/pdfInvoice/{cfdiId}',
        ...options
    });
};

export const getPageableInventoryControlRegistriesByPeriod = <ThrowOnError extends boolean = false>(options: Options<GetPageableInventoryControlRegistriesByPeriodData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPageableInventoryControlRegistriesByPeriodResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/getRegistersByPeriod',
        ...options
    });
};

export const downloadInventoryControlRegistries = <ThrowOnError extends boolean = false>(options: Options<DownloadInventoryControlRegistriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadInventoryControlRegistriesResponses, unknown, ThrowOnError>({
        responseType: 'blob',
        url: '/inventoryControl/downloadInventoryControlRegistries',
        ...options
    });
};

export const dailyInventoryControlNotification = <ThrowOnError extends boolean = false>(options?: Options<DailyInventoryControlNotificationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DailyInventoryControlNotificationResponses, unknown, ThrowOnError>({
        url: '/inventoryControl/dailyInventoryControlNotification',
        ...options
    });
};

export const existSmptConfig = <ThrowOnError extends boolean = false>(options?: Options<ExistSmptConfigData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExistSmptConfigResponses, unknown, ThrowOnError>({
        url: '/initial-config/smtp/exists',
        ...options
    });
};

export const onboardingStatus = <ThrowOnError extends boolean = false>(options?: Options<OnboardingStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<OnboardingStatusResponses, unknown, ThrowOnError>({
        url: '/initial-config/onboardingStatus',
        ...options
    });
};

export const existCompanyAdministrator = <ThrowOnError extends boolean = false>(options?: Options<ExistCompanyAdministratorData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExistCompanyAdministratorResponses, unknown, ThrowOnError>({
        url: '/initial-config/has-company-administator',
        ...options
    });
};

export const getCompanies = <ThrowOnError extends boolean = false>(options?: Options<GetCompaniesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompaniesResponses, unknown, ThrowOnError>({
        url: '/initial-config/company',
        ...options
    });
};

export const getHose = <ThrowOnError extends boolean = false>(options: Options<GetHoseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetHoseResponses, unknown, ThrowOnError>({
        url: '/hose/{id}',
        ...options
    });
};

export const checkIfHoseKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfHoseKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfHoseKeyExistResponses, unknown, ThrowOnError>({
        url: '/hose/checkIfHoseKeyExist/{hoseKey}',
        ...options
    });
};

export const checkIfAuditableHoseKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfAuditableHoseKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfAuditableHoseKeyExistResponses, unknown, ThrowOnError>({
        url: '/hose/checkIfAuditableHoseKeyExist/{auditableHoseKey}',
        ...options
    });
};

export const downloadHistoricalDataLayoutFile = <ThrowOnError extends boolean = false>(options: Options<DownloadHistoricalDataLayoutFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadHistoricalDataLayoutFileResponses, unknown, ThrowOnError>({
        responseType: 'blob',
        url: '/historicalData/downloadLayoutFile',
        ...options
    });
};

export const getHistoricalDataFilesStatus = <ThrowOnError extends boolean = false>(options: Options<GetHistoricalDataFilesStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetHistoricalDataFilesStatusResponses, unknown, ThrowOnError>({
        url: '/historicalData/currentFiles',
        ...options
    });
};

export const getProductSubProducts = <ThrowOnError extends boolean = false>(options: Options<GetProductSubProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProductSubProductsResponses, unknown, ThrowOnError>({
        url: '/getProductSubProducts/{idProduct}',
        ...options
    });
};

export const getProductActiveSubproducts = <ThrowOnError extends boolean = false>(options: Options<GetProductActiveSubproductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProductActiveSubproductsResponses, unknown, ThrowOnError>({
        url: '/getProductActiveSubproducts/{idProduct}',
        ...options
    });
};

export const getActiveProducts = <ThrowOnError extends boolean = false>(options?: Options<GetActiveProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetActiveProductsResponses, unknown, ThrowOnError>({
        url: '/getActiveProducts',
        ...options
    });
};

export const getApplicationVersion = <ThrowOnError extends boolean = false>(options?: Options<GetApplicationVersionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApplicationVersionResponses, unknown, ThrowOnError>({
        url: '/general/getApplicationVersion',
        ...options
    });
};

export const generateUserLogoutEvent = <ThrowOnError extends boolean = false>(options?: Options<GenerateUserLogoutEventData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GenerateUserLogoutEventResponses, unknown, ThrowOnError>({
        url: '/events/userLogout',
        ...options
    });
};

export const generateInactivityLogoutEvent = <ThrowOnError extends boolean = false>(options?: Options<GenerateInactivityLogoutEventData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GenerateInactivityLogoutEventResponses, unknown, ThrowOnError>({
        url: '/events/inactivityLogout',
        ...options
    });
};

export const getEventTypeFilter = <ThrowOnError extends boolean = false>(options?: Options<GetEventTypeFilterData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEventTypeFilterResponses, unknown, ThrowOnError>({
        url: '/events/getEventTypeFilter',
        ...options
    });
};

export const getEquipments = <ThrowOnError extends boolean = false>(options?: Options<GetEquipmentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEquipmentsResponses, unknown, ThrowOnError>({
        url: '/equipment',
        ...options
    });
};

export const getEquipment = <ThrowOnError extends boolean = false>(options: Options<GetEquipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEquipmentResponses, unknown, ThrowOnError>({
        url: '/equipment/{id}',
        ...options
    });
};

export const checkIfEquipmentKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfEquipmentKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfEquipmentKeyExistResponses, unknown, ThrowOnError>({
        url: '/equipment/checkIfEquipmentKeyExist/{equipmentKey}',
        ...options
    });
};

export const checkIfAuditableEquipmentKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfAuditableEquipmentKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfAuditableEquipmentKeyExistResponses, unknown, ThrowOnError>({
        url: '/equipment/checkIfAuditableEquipmentKeyExist/{auditableEquipmentKey}',
        ...options
    });
};

export const getEmailList = <ThrowOnError extends boolean = false>(options?: Options<GetEmailListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetEmailListResponses, unknown, ThrowOnError>({
        url: '/emailList',
        ...options
    });
};

export const getPageableDistributionPoints = <ThrowOnError extends boolean = false>(options: Options<GetPageableDistributionPointsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPageableDistributionPointsResponses, unknown, ThrowOnError>({
        url: '/distributionPointsPage',
        ...options
    });
};

export const getLastMeasurement = <ThrowOnError extends boolean = false>(options: Options<GetLastMeasurementData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLastMeasurementResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{idDistributionPoint}/lastMeasurement',
        ...options
    });
};

export const getWareHouses1 = <ThrowOnError extends boolean = false>(options: Options<GetWareHouses1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWareHouses1Responses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/warehouses',
        ...options
    });
};

export const getWareHousesByDistributionPointAndType = <ThrowOnError extends boolean = false>(options: Options<GetWareHousesByDistributionPointAndTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWareHousesByDistributionPointAndTypeResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/warehouseTypes',
        ...options
    });
};

export const getAllEquipmentsByApplicationType = <ThrowOnError extends boolean = false>(options: Options<GetAllEquipmentsByApplicationTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllEquipmentsByApplicationTypeResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/inputEquipment',
        ...options
    });
};

export const getOriginTypeFilter = <ThrowOnError extends boolean = false>(options: Options<GetOriginTypeFilterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOriginTypeFilterResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/eventOriginTypes',
        ...options
    });
};

export const getEquipmentsByDistributionPoint = <ThrowOnError extends boolean = false>(options: Options<GetEquipmentsByDistributionPointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetEquipmentsByDistributionPointResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/equipments',
        ...options
    });
};

export const getAllDispensaries = <ThrowOnError extends boolean = false>(options: Options<GetAllDispensariesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllDispensariesResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/dispensaries',
        ...options
    });
};

export const getDictumlessReceptionsByDistributionPointId = <ThrowOnError extends boolean = false>(options: Options<GetDictumlessReceptionsByDistributionPointIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDictumlessReceptionsByDistributionPointIdResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/dictumLessReceptions',
        ...options
    });
};

export const getContainers = <ThrowOnError extends boolean = false>(options: Options<GetContainersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContainersResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/containers',
        ...options
    });
};

export const checkIfWareHouseKeyExistInPdd = <ThrowOnError extends boolean = false>(options: Options<CheckIfWareHouseKeyExistInPddData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfWareHouseKeyExistInPddResponses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/checkIfWareHouseKeyExist',
        ...options
    });
};

export const checkIfAuditableEquipmentKeyExist1 = <ThrowOnError extends boolean = false>(options: Options<CheckIfAuditableEquipmentKeyExist1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfAuditableEquipmentKeyExist1Responses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/checkIfAuditableEquipmentKeyExist',
        ...options
    });
};

export const getActiveProductsByDistributionPoint1 = <ThrowOnError extends boolean = false>(options: Options<GetActiveProductsByDistributionPoint1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetActiveProductsByDistributionPoint1Responses, unknown, ThrowOnError>({
        url: '/distributionPoints/{distributionPointId}/activeProducts',
        ...options
    });
};

export const getDispensaryEquipmentsByDispensaryCode = <ThrowOnError extends boolean = false>(options: Options<GetDispensaryEquipmentsByDispensaryCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDispensaryEquipmentsByDispensaryCodeResponses, unknown, ThrowOnError>({
        url: '/dispensary/getDispensaryEquipments/{dispensaryCode}',
        ...options
    });
};

export const getDictumById = <ThrowOnError extends boolean = false>(options: Options<GetDictumByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDictumByIdResponses, unknown, ThrowOnError>({
        url: '/dictum/{id}',
        ...options
    });
};

export const downloadDictumFile = <ThrowOnError extends boolean = false>(options: Options<DownloadDictumFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadDictumFileResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/dictum/{dictumId}/{fileType}',
        ...options
    });
};

export const validateDailyJsonSchemaWs = <ThrowOnError extends boolean = false>(options?: Options<ValidateDailyJsonSchemaWsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ValidateDailyJsonSchemaWsResponses, unknown, ThrowOnError>({
        url: '/dashboard/validateJsonSchemaWs',
        ...options
    });
};

export const validateJsonSchemaWsMonth = <ThrowOnError extends boolean = false>(options?: Options<ValidateJsonSchemaWsMonthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ValidateJsonSchemaWsMonthResponses, unknown, ThrowOnError>({
        url: '/dashboard/validateJsonSchemaWsMonth',
        ...options
    });
};

export const createLiveStatusSocketConection = <ThrowOnError extends boolean = false>(options?: Options<CreateLiveStatusSocketConectionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CreateLiveStatusSocketConectionResponses, unknown, ThrowOnError>({
        url: '/dashboard/executeLiveStatus',
        ...options
    });
};

export const getAllCorruptedDataRegisters = <ThrowOnError extends boolean = false>(options?: Options<GetAllCorruptedDataRegistersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllCorruptedDataRegistersResponses, unknown, ThrowOnError>({
        url: '/corruptedDataStorage/getAllRegisters',
        ...options
    });
};

export const getContainerById = <ThrowOnError extends boolean = false>(options: Options<GetContainerByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetContainerByIdResponses, unknown, ThrowOnError>({
        url: '/container/{idContainer}',
        ...options
    });
};

export const getInstallationKeys = <ThrowOnError extends boolean = false>(options?: Options<GetInstallationKeysData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInstallationKeysResponses, unknown, ThrowOnError>({
        url: '/container/tankKeys',
        ...options
    });
};

export const integrationCodeExists = <ThrowOnError extends boolean = false>(options: Options<IntegrationCodeExistsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<IntegrationCodeExistsResponses, unknown, ThrowOnError>({
        url: '/container/integration-code/exists',
        ...options
    });
};

export const getDuctKeys = <ThrowOnError extends boolean = false>(options?: Options<GetDuctKeysData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDuctKeysResponses, unknown, ThrowOnError>({
        url: '/container/ductKeys',
        ...options
    });
};

export const countIfExistContainers = <ThrowOnError extends boolean = false>(options?: Options<CountIfExistContainersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CountIfExistContainersResponses, unknown, ThrowOnError>({
        url: '/container/countIfExistContainers',
        ...options
    });
};

export const checkIfContainerKeyExist = <ThrowOnError extends boolean = false>(options: Options<CheckIfContainerKeyExistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckIfContainerKeyExistResponses, unknown, ThrowOnError>({
        url: '/container/checkIfContainerKeyExist/{containerKey}',
        ...options
    });
};

export const getConfigApplication = <ThrowOnError extends boolean = false>(options?: Options<GetConfigApplicationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetConfigApplicationResponses, unknown, ThrowOnError>({
        url: '/configApplication/getConfig',
        ...options
    });
};

export const allowManualWarehouseLevel = <ThrowOnError extends boolean = false>(options?: Options<AllowManualWarehouseLevelData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AllowManualWarehouseLevelResponses, unknown, ThrowOnError>({
        url: '/configApplication/getConfig/allowManualWarehouseLevel',
        ...options
    });
};

export const getIncoterms = <ThrowOnError extends boolean = false>(options?: Options<GetIncotermsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetIncotermsResponses, unknown, ThrowOnError>({
        url: '/complement/getIncoterms',
        ...options
    });
};

export const getCountries = <ThrowOnError extends boolean = false>(options?: Options<GetCountriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCountriesResponses, unknown, ThrowOnError>({
        url: '/complement/getCountries',
        ...options
    });
};

export const getCompany = <ThrowOnError extends boolean = false>(options: Options<GetCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCompanyResponses, unknown, ThrowOnError>({
        url: '/company/{id}',
        ...options
    });
};

export const getRegulatoryPermissionKeys = <ThrowOnError extends boolean = false>(options?: Options<GetRegulatoryPermissionKeysData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegulatoryPermissionKeysResponses, unknown, ThrowOnError>({
        url: '/company/regulatoryPermissionKeys',
        ...options
    });
};

export const getInstallationKeys1 = <ThrowOnError extends boolean = false>(options?: Options<GetInstallationKeys1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInstallationKeys1Responses, unknown, ThrowOnError>({
        url: '/company/installationKeys',
        ...options
    });
};

export const getCompanyInstallationKey = <ThrowOnError extends boolean = false>(options?: Options<GetCompanyInstallationKeyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompanyInstallationKeyResponses, unknown, ThrowOnError>({
        url: '/company/installationKey',
        ...options
    });
};

export const getCompanyActivityTypes = <ThrowOnError extends boolean = false>(options?: Options<GetCompanyActivityTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCompanyActivityTypesResponses, unknown, ThrowOnError>({
        url: '/company/companyActivityTypes',
        ...options
    });
};

export const searchCfdis = <ThrowOnError extends boolean = false>(options: Options<SearchCfdisData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchCfdisResponses, unknown, ThrowOnError>({
        url: '/cfdis/search',
        ...options
    });
};

export const deletePg = <ThrowOnError extends boolean = false>(options: Options<DeletePgData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePgResponses, unknown, ThrowOnError>({
        url: '/pgs/deletePg/{pgId}',
        ...options
    });
};

export const deleteEmailConfiguration = <ThrowOnError extends boolean = false>(options: Options<DeleteEmailConfigurationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteEmailConfigurationResponses, unknown, ThrowOnError>({
        url: '/outputEmail/deleteEmailConfiguration/{idEmailConfiguration}',
        ...options
    });
};

export const deleteHistoricalLayoutFile = <ThrowOnError extends boolean = false>(options: Options<DeleteHistoricalLayoutFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteHistoricalLayoutFileResponses, unknown, ThrowOnError>({
        url: '/historicalData/deleteLayoutFile',
        ...options
    });
};

export const deleteAndMigrateHistoricalDataLayouts = <ThrowOnError extends boolean = false>(options: Options<DeleteAndMigrateHistoricalDataLayoutsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteAndMigrateHistoricalDataLayoutsResponses, unknown, ThrowOnError>({
        url: '/historicalData/deleteAndMigrateHistoricalDataLayouts',
        ...options
    });
};

export const deleteEquipment = <ThrowOnError extends boolean = false>(options: Options<DeleteEquipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteEquipmentResponses, unknown, ThrowOnError>({
        url: '/equipment/{idEquipment}',
        ...options
    });
};

export const deleteDictum = <ThrowOnError extends boolean = false>(options: Options<DeleteDictumData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteDictumResponses, unknown, ThrowOnError>({
        url: '/dictum/deleteDictum/{dictumId}',
        ...options
    });
};

export const deleteContainer = <ThrowOnError extends boolean = false>(options: Options<DeleteContainerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteContainerResponses, unknown, ThrowOnError>({
        url: '/container/delete/{idContainer}',
        ...options
    });
};